import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetNotificationPreferencesV1Response } from './get-notification-preferences-v1-response';
import { getNotificationPreferencesV1ResponseSchema } from './get-notification-preferences-v1-response';

export async function getNotificationPreferencesV1Api(
  options?: IRequestOptions,
): Promise<IValidatedResponse<IGetNotificationPreferencesV1Response>> {
  return getRequest<IGetNotificationPreferencesV1Response>({
    path: '/account/notification-preferences/v1',
    schema: getNotificationPreferencesV1ResponseSchema,
    options,
  });
}
